import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import {
  EnumToArrayPipe,
  FormatNumber,
  FormatNumberStr,
  DateFormatPipe,
} from './pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { EnumPipe } from './pipe/enum.pipe';
import { StatusColorPipe } from './pipe/status-color.pipe';
import { MatListModule } from '@angular/material/list';
import { ArrayToStringPipe } from './pipe/array-to-string.pipe';

@NgModule({
  declarations: [
    EnumToArrayPipe,
    FormatNumberStr,
    FormatNumber,
    EnumPipe,
    StatusColorPipe,
    DateFormatPipe,
    ArrayToStringPipe
  ],
  exports: [
    CommonModule,
    EnumToArrayPipe,
    DateFormatPipe,
    FormatNumberStr,
    FormatNumber,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatPaginatorModule,
    MatIconModule,
    MatCheckboxModule,
    MatDialogModule,
    MatAutocompleteModule,
    FormsModule,
    MatRadioModule,
    MatTooltipModule,
    MatChipsModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonToggleModule,
    EnumPipe,
    MatListModule,
    ArrayToStringPipe
  ],
})
export class SharedModule {
}
